export const SUPPORT_CONTENT = {
  es: {
    pageTitle: "Soporte – Cyrqle",
    metaDescription:
      "Centro de soporte de Cyrqle: qué hace la app, relación con laboratorios y cómo contactarnos.",
    lastUpdated: "Última actualización: junio 2026",
    back: "Volver al inicio",
    intro:
      "Estamos aquí para ayudarte con el uso de la aplicación y cualquier duda sobre los datos de salud de tu familia en Cyrqle.",
    contactEmail: "soporte@sentinelzone.com",
    sections: [
      {
        title: "Qué hace Cyrqle (y qué no hace)",
        paragraphs: [
          "Cyrqle no emite recomendaciones médicas, dietéticas ni de suplementación.",
          "La aplicación te ayuda a interpretar y organizar los resultados de los análisis de laboratorio de tu círculo para cuidar mejor su bienestar.",
          "Los datos son tuyos: tú decides qué información introduces, cómo la consultas y cómo acompañas a los tuyos.",
        ],
        listItems: [
          "No sustituimos la opinión de un profesional sanitario",
          "No prescribimos tratamientos ni cambios de hábitos",
          "No tomamos decisiones clínicas por ti",
        ],
        closing: [
          "Cyrqle es una herramienta de interpretación y visualización para el bienestar de tu familia. Las conclusiones sobre salud deben validarse siempre con su profesional sanitario.",
        ],
      },
      {
        title: "Relación con laboratorios",
        paragraphs: [
          "Cyrqle no colabora con laboratorios ni mantiene acuerdos comerciales con ellos.",
          "Somos un intermediario tecnológico de la información de laboratorio que tú nos facilitas o importas desde tu propio informe.",
          "No emitimos informes clínicos oficiales ni modificamos los resultados originales de tu laboratorio.",
        ],
        listItems: [
          "Tú eres el titular de tus datos y de tu informe",
          "La responsabilidad del análisis y su validez corresponde al laboratorio que lo realizó",
          "Cyrqle organiza y explica la información que tú decides compartir con la app",
        ],
      },
      {
        title: "Cómo podemos ayudarte",
        paragraphs: [
          "Podemos atender consultas sobre el funcionamiento de la app, la importación de análisis, la cuenta de usuario y el tratamiento de tus datos.",
          "Para dudas técnicas o sobre el servicio, escríbenos a:",
        ],
        contact: true,
      },
    ],
  },
  en: {
    pageTitle: "Support – Cyrqle",
    metaDescription:
      "Cyrqle support center: what the app does, relationship with laboratories, and how to contact us.",
    lastUpdated: "Last updated: June 2026",
    back: "Back to home",
    intro:
      "We are here to help you with the application and any questions about your family's health data in Cyrqle.",
    contactEmail: "soporte@sentinelzone.com",
    sections: [
      {
        title: "What Cyrqle does (and does not do)",
        paragraphs: [
          "Cyrqle does not provide medical, dietary, or supplement recommendations.",
          "The app helps you interpret and organize laboratory test results for your circle so you can care better for their wellness.",
          "The data is yours: you decide what information you enter, how you review it, and how you support your loved ones.",
        ],
        listItems: [
          "We do not replace the opinion of a healthcare professional",
          "We do not prescribe treatments or lifestyle changes",
          "We do not make clinical decisions for you",
        ],
        closing: [
          "Cyrqle is an interpretation and visualization tool for your family's wellness. Health conclusions should always be validated with their healthcare professional.",
        ],
      },
      {
        title: "Relationship with laboratories",
        paragraphs: [
          "Cyrqle does not collaborate with laboratories and has no commercial agreements with them.",
          "We act as a technology intermediary for the laboratory information you provide or import from your own report.",
          "We do not issue official clinical reports or modify the original results from your laboratory.",
        ],
        listItems: [
          "You are the owner of your data and your report",
          "Responsibility for the test and its validity lies with the laboratory that performed it",
          "Cyrqle organizes and explains the information you choose to share with the app",
        ],
      },
      {
        title: "How we can help",
        paragraphs: [
          "We can help with questions about how the app works, importing test results, your user account, and how your data is handled.",
          "For technical or service questions, email us at:",
        ],
        contact: true,
      },
    ],
  },
  fr: {
    pageTitle: "Support – Cyrqle",
    metaDescription:
      "Centre de support Cyrqle : rôle de l'app, relation avec les laboratoires et contact.",
    lastUpdated: "Dernière mise à jour : juin 2026",
    back: "Retour à l'accueil",
    intro:
      "Nous sommes là pour vous aider avec l'application et toute question sur les données de santé de votre famille dans Cyrqle.",
    contactEmail: "soporte@sentinelzone.com",
    sections: [
      {
        title: "Ce que fait Cyrqle (et ce qu'il ne fait pas)",
        paragraphs: [
          "Cyrqle ne fournit pas de recommandations médicales, diététiques ou de supplémentation.",
          "L'application vous aide à interpréter et organiser les résultats des analyses de laboratoire de votre cercle pour mieux prendre soin de leur bien-être.",
          "Les données vous appartiennent : vous décidez quelles informations vous saisissez et comment vous accompagnez vos proches.",
        ],
        listItems: [
          "Nous ne remplaçons pas l'avis d'un professionnel de santé",
          "Nous ne prescrivons ni traitements ni changements d'habitudes",
          "Nous ne prenons pas de décisions cliniques à votre place",
        ],
        closing: [
          "Cyrqle est un outil d'interprétation et de visualisation pour le bien-être de votre famille. Toute conclusion sur la santé doit être validée avec leur professionnel de santé.",
        ],
      },
      {
        title: "Relation avec les laboratoires",
        paragraphs: [
          "Cyrqle ne collabore pas avec les laboratoires et n'a aucun accord commercial avec eux.",
          "Nous agissons comme intermédiaire technologique des informations de laboratoire que vous nous transmettez ou importez depuis votre propre rapport.",
          "Nous n'émettons pas de rapports cliniques officiels et ne modifions pas les résultats originaux de votre laboratoire.",
        ],
        listItems: [
          "Vous êtes titulaire de vos données et de votre rapport",
          "La responsabilité de l'analyse et de sa validité incombe au laboratoire qui l'a réalisée",
          "Cyrqle organise et explique les informations que vous choisissez de partager avec l'app",
        ],
      },
      {
        title: "Comment nous aider",
        paragraphs: [
          "Nous pouvons répondre aux questions sur le fonctionnement de l'app, l'importation d'analyses, le compte utilisateur et le traitement de vos données.",
          "Pour toute question technique ou sur le service, écrivez-nous à :",
        ],
        contact: true,
      },
    ],
  },
  ca: {
    pageTitle: "Suport – Cyrqle",
    metaDescription:
      "Centre de suport de Cyrqle: què fa l'app, relació amb laboratoris i com contactar-nos.",
    lastUpdated: "Darrera actualització: juny 2026",
    back: "Tornar a l'inici",
    intro:
      "Som aquí per ajudar-te amb l'aplicació i qualsevol dubte sobre les dades de salut de la teva família a Cyrqle.",
    contactEmail: "soporte@sentinelzone.com",
    sections: [
      {
        title: "Què fa Cyrqle (i què no fa)",
        paragraphs: [
          "Cyrqle no emet recomanacions mèdiques, dietètiques ni de suplementació.",
          "L'aplicació t'ajuda a interpretar i organitzar els resultats dels anàlisis de laboratori del teu cercle per cuidar millor el seu benestar.",
          "Les dades són teves: tu decideixes quina informació introdueixes i com acompanyes els teus.",
        ],
        listItems: [
          "No substituïm l'opinió d'un professional sanitari",
          "No prescriuem tractaments ni canvis d'hàbits",
          "No prenem decisions clíniques per tu",
        ],
        closing: [
          "Cyrqle és una eina d'interpretació i visualització per al benestar de la teva família. Les conclusions sobre salut s'han de validar sempre amb el seu professional sanitari.",
        ],
      },
      {
        title: "Relació amb laboratoris",
        paragraphs: [
          "Cyrqle no col·labora amb laboratoris ni manté acords comercials amb ells.",
          "Som un intermediari tecnològic de la informació de laboratori que tu ens facilites o importes des del teu propi informe.",
          "No emetem informes clínics oficials ni modifiquem els resultats originals del teu laboratori.",
        ],
        listItems: [
          "Tu ets el titular de les teves dades i del teu informe",
          "La responsabilitat de l'anàlisi i la seva validesa correspon al laboratori que el va realitzar",
          "Cyrqle organitza i explica la informació que tu decideixes compartir amb l'app",
        ],
      },
      {
        title: "Com podem ajudar-te",
        paragraphs: [
          "Podem atendre consultes sobre el funcionament de l'app, la importació d'anàlisis, el compte d'usuari i el tractament de les teves dades.",
          "Per a dubtes tècnics o sobre el servei, escriu-nos a:",
        ],
        contact: true,
      },
    ],
  },
};
